@use "../../../../variables" as *;

.header-container {
  background-color: $white;
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;

  svg {
    fill: $grey;
    height: 1.125rem;
    width: 1.125rem;
  }

  .arrows {
    color: $grey;
    display: flex;

    svg {
      vertical-align: text-bottom;
    }

    .arrow > span {
      cursor: pointer;
    }

    .arrow {
      width: 1.25rem;
      margin: 0;
      padding: 0;
      background: none;
      border: none;
    }

    .divider {
      margin-left: 0.25rem;
      margin-right: 0.25rem;
      width: 0.25rem;
    }

    .disabled {
      color: $grey-lighter;
      cursor: not-allowed;
      pointer-events: none;

      svg {
        fill: $grey-lighter;
      }
    }
  }

  .info {
    letter-spacing: 0.05rem;

    a {
      color: $grey-text;
    }
  }

  .close {
    background: none;
    border: none;
    cursor: pointer;
  }
}